// pages/CategoryPage.jsx

import { useParams } from 'react-router-dom';
import Header from '../components/Header'
import Spicy1 from '../assets/malagueta-level-1.png'
import Spicy2 from '../assets/malagueta-level-2.png'
import Spicy3 from '../assets/malagueta-level-3.png'
import Leaf from '../assets/folha.png'
import { useLanguage } from '../context/LanguageContext';
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';



export const ListingItems = () => {
    const { categoryId, subcategoryId } = useParams();
    const { language } = useLanguage();
    const [data, setData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`/assets/data.json?_=${Date.now()}`)
            .then(res => res.json())
            .then(setData);
    }, []);

    if (!data) return <div class="text-white font-bold w-full text-align">Loading...</div>;

    const category = data.categories.find(c => c.id === categoryId);

    let items = [];

    let heading = '';

    if (category?.hasSubcategories && subcategoryId) {
        const subcategory = category?.subcategories?.find(sc => sc.id === subcategoryId);
        items = subcategory?.items || [];
        heading = subcategory.name[language];
    } else {
        items = category?.items || [];
        heading = category.name[language];
    }

    return (
        <div className="">
            <Header />
            {/* Heading + Back Link */}
            <div className="p-4 flex items-center justify-between mt-4">
                <button onClick={() => navigate(-1)} className="text-black px-2 hover:bg-gray-300 relative z-10 bg-white rounded">
                    ← {language === 'en' ? 'Back' : 'Voltar'}
                </button>
                <h1 className="text-3xl font-bold text-white absolute w-full text-center right-0">
                    {heading}
                </h1>
            </div>
            <ul className='flex flex-wrap flex-row'>
                {items.map((item) => {
                    return (
                        <li className="w-full lg:w-6/12 xl:w-4/12 px-2" key={item.id}>
                            <div className="p-5 my-4 border-2 border-b-8 border-[#33525a] flex flex-col justify-around rounded-xl">
                                <p className='item-name-heading text-white text-5xl'><b>{item.name[language]}</b></p>
                                {item.description && (
                                    <p className='text-white description text-base'>{item.description[language]}</p>
                                )}
                                {item.sauce ? (
                                    <p className='text-white description text-base mt-3'><b>Molho:</b> {item.sauce[language]}</p>
                                ) : (
                                    null
                                )}
                                {item.spicy ? (
                                    <div className={`flex flex-row pt-10 items-center ${item.spicy ? 'justify-between' : 'justify-end'} spices-img`}>
                                        {item.spicy === 1 ? (
                                            <img src={Spicy1} alt={`Spicy Level ${item.spicy}`} />
                                        ) : null}
                                        {item.spicy === 2 ? (
                                            <img src={Spicy2} alt={`Spicy Level ${item.spicy}`} />
                                        ) : null}
                                        {item.spicy === 3 ? (
                                            <img src={Spicy3} alt={`Spicy Level ${item.spicy}`} />
                                        ) : null}
                                        {item.veggie ? (
                                            <img className="mx-8" src={Leaf} alt={`Spicy Level ${item.spicy}`} />
                                        ) : null}
                                        <p className='text-white text-end text-6xl font-bold'>{item.price.toFixed(2)}€</p>
                                    </div>
                                ) : (
                                    <div className={`flex flex-row pt-10 items-center ${item.spicy ? 'justify-between' : 'justify-end'} spices-img`}>
                                        <p className='text-white text-end text-6xl font-bold'>{item.price.toFixed(2)}€</p>
                                    </div>
                                )}
                            </div>
                        </li>
                    )
                })}
            </ul>
        </div>
    );
}